import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof detail === "object") {
    for (const k of ["message", "msg", "detail", "error"]) {
      if (typeof detail[k] === "string" && detail[k]) return detail[k];
    }
    try { return JSON.stringify(detail); } catch { return "Si è verificato un errore. Riprova."; }
  }
  return String(detail);
}

// Messaggio leggibile da un errore Axios (mai "[object Object]").
export function apiErrorMessage(e) {
  const data = e?.response?.data;
  if (data?.detail !== undefined) return formatApiErrorDetail(data.detail);
  if (typeof data === "string" && data) return data;
  if (e?.response?.status) return `Errore ${e.response.status}`;
  return e?.message || "Si è verificato un errore. Riprova.";
}

// --- Auto-refresh del token di accesso (access token TTL 15 min, refresh 7 giorni) ---
// Il refresh è serializzato tramite una singola promise condivisa: più richieste
// che ricevono 401 contemporaneamente attendono lo stesso refresh (nessuna race).
let refreshPromise = null;

const AUTH_SKIP = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (!response || response.status !== 401 || !config || config._retry) {
      return Promise.reject(error);
    }
    const url = config.url || "";
    if (AUTH_SKIP.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    config._retry = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api
          .post("/auth/refresh")
          .finally(() => {
            refreshPromise = null;
          });
      }
      await refreshPromise;
      return api(config); // riprova la richiesta originale col nuovo access token
    } catch (refreshError) {
      // Refresh fallito: sessione realmente scaduta -> torna al login
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.assign("/login");
      }
      return Promise.reject(error);
    }
  }
);

export default api;
export { API };
